import IVenue from "../../../interfaces/IVenue";
import { ActiveTab } from "../../ordersSetting/types";
import { SET_VENUE_GROUPS, SET_ACTIVE_TAB_STATE, SET_GROUP_DETAILS  } from "./groupsManagement.actions";


export interface IVenueGroup {
    id:string;
    name_public: string;
    name_internal:string;
    nickname:string;
    venues: IVenue[];
    group_settings:{
        id:string;
        multi_ordering_enabled:boolean;
        tipping_options_override:boolean;
        venue_group_id:string;
        default_tipping_option_id?:string;
        has_multi_ordering_permission ?:boolean;
    },
    logo_group?:string;
  }
  
  
export interface IGroupSettingsState {
    activeTab:{
        key:string
    },
    groups: IVenueGroup[],
    group?: IVenueGroup
}

export const initialState = {
    groups : [],
    activeTab:{
        key:"GENERAL"
    }
}

interface IAction
{
    type: string;
    payload: unknown
}

export const groupSettingsReducer = (state: IGroupSettingsState  = initialState , action: IAction) => {
    switch (action.type) {
        case SET_VENUE_GROUPS:
            return {
                ...state,
                 groups : action.payload as IVenueGroup[]
            } 
        case SET_ACTIVE_TAB_STATE:
            return {
                ...state,
                activeTab: action.payload as ActiveTab,
            };
        case SET_GROUP_DETAILS:
            console.log('first', action.payload)
            return {
                ...state,
                group: action.payload as IVenueGroup,
            };
    }
    return state;
};

